import { useMemo } from "react";
import i18n from "@shared/i18n";

export type Direction = "ltr" | "rtl";

export function getDirection(language = i18n?.language || "en"): Direction {
  return language.startsWith("ar") ? "rtl" : "ltr";
}

export function useDirection(): Direction {
  return useMemo(() => getDirection(), []);
}
